import React, { useState, useEffect } from "react";

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleClick = (e) => {
      const btn = document.getElementById("hamburger");
      const menu = document.getElementById("mobileMenu");
      if (btn && menu && !btn.contains(e.target) && !menu.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return (
    <>
      <nav>
        <div className="nav-inner">
          <a href="/" className="nav-logo">
            <img
              loading="lazy"
              src="https://www.verdemobility.com/static/media/logo.33ea012dec70e5ad4e172b81c8732799.svg"
              width="175"
              alt="Verdemobility"
            />
          </a>
          <button
            className={`nav-hamburger${menuOpen ? " open" : ""}`}
            id="hamburger"
            aria-label="Menu"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <ul className="nav-links">
            <li><a href="#features">Features</a></li>
            <li><a href="#specs">Specifications</a></li>
            <li><a href="#variants">Models</a></li>
            <li><a href="#usecases">Use Cases</a></li>
            <li>
              <a href="/get-in-touch#contact-us" className="nav-cta">
                Enquire Now
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className={`mobile-menu${menuOpen ? " open" : ""}`} id="mobileMenu">
        <a href="#features" onClick={() => setMenuOpen(false)}>Features</a>
        <a href="#specs" onClick={() => setMenuOpen(false)}>Specifications</a>
        <a href="#variants" onClick={() => setMenuOpen(false)}>Models</a>
        <a href="#usecases" onClick={() => setMenuOpen(false)}>Use Cases</a>
        <a
          href="/get-in-touch#contact-us"
          className="mobile-cta"
          onClick={() => setMenuOpen(false)}
        >
          Enquire Now
        </a>
      </div>
    </>
  );
}
